export const authQueryKeys = {
  me: ["me"] as const
}
